<template>
  <div style="height: 100%; width: 100%">
    <div class="header">
      <div
        @click="toIndex"
        v-if="showLeftTop"
        class="selectRange"
        style="
          justify-content: initial;
          cursor: pointer;
          position: relative;
          z-index: 99;
        "
      >
        <img
          @click="toIndex"
          v-if="showLeftTop && showLeftTopAlways"
          :src="(title == '光明肉业' || homePage == '梅林首页') ? $images.logory : $images.logo"
          class="logoimage"
          :style="(title == '光明肉业' || homePage == '梅林首页')?'width:12vw;height:auto;':'width: 3vw; height: 3vw; margin-right: 5%; margin-left: 4vw;margin-bottom:1vw;'"
          alt=""
        />
        <img
          @click="toIndex"
          v-if="showLeftTop && !(title == '光明肉业' || homePage == '梅林首页') && showLeftTopAlways"
          :src="(title == '光明肉业' || homePage == '梅林首页') ? $images.wordry : $images.logoword"
          :style="'margin-bottom:1.3vw;margin-top:'+((title == '光明肉业' || homePage == '梅林首页')?'0;margin-bottom:1vw;width:10vw;':'0.3vw;width:10vw;')"
          alt=""
        />
        <Menu
          mode="horizontal"
          @on-select="(name) => $router.push(name)"
          :active-name="$route.name"
        >
        </Menu>
      </div>
      <div v-else></div>
      <div
        class="titleWrap"
        :style="{
          textAlign: 'center',
          position: 'absolute',
          marginLeft: 'auto',
          marginRight: 'auto',
          width: '100%',
          top: '10px',
          height: '50%',
          background: 'url(' + $images.img4 + ') no-repeat 0 0',
          backgroundSize: '100%',
        }"
      >
        <div class="header-title">{{ title }}</div>
      </div>
      <div class="selectRange" v-if="showRightTop">
        <div class="time">
          <div class="part">{{ timeInfo }}</div>
          <!-- <div class="part">{{ weatherInfo.date }} {{ getTime() }}</div>
          <div class="part">{{ weatherInfo.city }}</div>
          <div class="part">{{ weatherInfo.week }}</div>
          <div class="part">{{ weatherInfo.wea }} {{ weatherInfo.win }}</div> -->
        </div>
        <el-button
          @click="toKriDetail()"
          size="mini"
          class="logoimage"
          style="
            margin-right: 4vw;
            position: relative;
            z-index: 1;
            background-color: #937f56;
            color: #fff;
            border-color: #937f56;
          "
          >{{ rightButtonValue ? "预警详情" : "KRI Detail" }}</el-button
        >

        <!-- <img
          @click="toKriDetail()"
          :src="$images.logo"
          class="logoimage"
          style="width: 48px; height: 48px; margin-right: 10%"
          alt=""
        /> -->
      </div>
    </div>
    <Modal
      v-model="modal"
      title="选择时间"
      :mask-closable="false"
      @on-ok="getMonthBetween(startTime, endTime)"
    >
      <DatePicker
        @on-change="pickStartDate"
        :options="optionStart"
        type="date"
        placeholder="选择开始日期"
        style="width: 200px"
      ></DatePicker>
      <span style="padding: 0 20px; color: #75deef">至</span>
      <DatePicker
        @on-change="pickEndDate"
        :options="optionEnd"
        type="date"
        placeholder="选择结束日期"
        style="width: 200px"
      ></DatePicker>
    </Modal>
    <div class="page">
      <router-view v-if="flag" :selectRangeDate="selectRangeDate"></router-view>
    </div>
  </div>
</template>

<script>
import { getWeather } from "@/api";
import { useDataStore } from "@/store";
import { mapState, mapActions } from "pinia";
export default {
  name: "",
  computed: {
    ...mapState(useDataStore, [
      "rightButtonValue",
      "title",
      "showLeftTop",
      "showRightTop",
      "backUrl",
      "showLeftTopAlways"
    ]),
  },
  data() {
    return {
      homePage:'',
      timer: null,
      timeInfo: "",
      weatherInfo: {},
      activeName: "month", // 默认显示近一月
      modal: false,
      flag: false,
      selectRangeDate: [],
      startTime: "",
      endTime: "",
      optionStart: {
        disabledDate(date) {
          // 禁止选择今天之后的日期
          return date && date.valueOf() > Date.now() - 86400000;
        },
      },
      optionEnd: {},
      resizeFn: null,
    };
  },
  created() {
    let url = document.location.href;
    let reg = /[^\w]('tokan')=?([^&|^#]*)/g;
    url = url.replace(reg, "");
    reg = /&&/g;
    url = url.replace(reg, "");
    reg = /&#/g;
    url = url.replace(reg, "#");
    reg = /\?#/g;
    url = url.replace(reg, "#");
    // url = url.replaceAll(document.domain,"");
    // url = url.replaceAll("http://","");
    // url = url.replaceAll("https://","");
    reg = /\?#/g;
    window.history.replaceState(null, null, url);

    // this.$route.replace({
    //   path: "/PC/home",
    //   query: {},
    // });
  },
  mounted() {
    window.addEventListener("resize", this.resizeFn);
    this.handleSelect(this.activeName); // 默认显示近一个月
    // this.getWeatherInfo();
    this.getTimeInfo();
    let userInfo = localStorage.getItem("bbsUserInfo");
      if (userInfo) {
        let userInfoJson = JSON.parse(userInfo);
        this.homePage = userInfoJson.homePage
        if(this.homePage == '集团纪委首页'){
          this.showLeftTopAlways(false)
        }
      }
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle"]),
    getTimeInfo() {
      let type = 1;
      let userInfo = localStorage.getItem("bbsUserInfo");
      if (userInfo) {
        this.setTitle(JSON.parse(userInfo).companyName);
        let title = JSON.parse(userInfo).companyName;
        if (
          title == "Bright Food Asia Pacific Pty Ltd." ||
          title == "Salov S.p.A"
        ) {
          type = 2;
        }
      }
      // 创建一个Date对象，它将包含当前的日期和时间
      var currentDate = new Date();
      // 获取年份
      var year = currentDate.getFullYear();
      // 获取月份（注意月份是从0开始的，所以要加1）
      var month = currentDate.getMonth() + 1;
      // 获取日期
      var day = currentDate.getDate();
      // 获取星期几的数字（0表示星期日，1表示星期一，以此类推）
      var dayOfWeek = currentDate.getDay();
      // 将数字转换为星期几的文本形式
      var daysOfWeek = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      if (type == 2) {
        daysOfWeek = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
      }
      var today = daysOfWeek[dayOfWeek];
      // 格式化成指定的字符串形式
      var formattedDate = year + "年" + month + "月" + day + "日 " + today;
      if (type == 2) {
        formattedDate = year + "-" + month + "-" + day + " " + today;
      }
      this.timeInfo = formattedDate;
    },
    toKriDetail() {
      this.$router.push("/kriDetail");
    },
    throttle(wait) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, wait);
        if (useDataStore().showLeftTop) {
          if (useDataStore().backUrl == "back") {
            this.$router.back();
          } else {
            this.$router.replace(this.backUrl || "/");
          }
        }
      }
    },

    toIndex() {
      if (useDataStore().title == "光明肉业") {
        return;
      }
      this.throttle(300);
    },
    getTime() {
      // 获取当前时间
      const currentTime = new Date();

      // 获取小时和分钟
      const hours = currentTime.getHours().toString().padStart(2, "0");
      const minutes = currentTime.getMinutes().toString().padStart(2, "0");

      // 格式化时间为 "14:22" 形式
      const formattedTime = `${hours}:${minutes}`;

      return formattedTime;
    },
    async getWeatherInfo() {
      const res = await getWeather();
      if (res.code == 200) {
        this.weatherInfo = res.data;
      }
    },
    pickStartDate(date) {
      // 选择开始时间的回调
      this.startTime = date;
      this.optionEnd = {
        disabledDate(d) {
          // 禁止选择开始时间之前的日期
          return d && d.valueOf() < new Date(date).valueOf() - 86400000;
        },
      };
    },
    pickEndDate(date) {
      // 选择结束时间的回调
      this.endTime = date;
    },
    getMonthBetween(start, end) {
      // 获取开始时间和结束时间之内的所有月份
      this.selectRangeDate = [];
      let s = start.split("-"); // 字符串装换数组
      let e = end.split("-");
      let date = new Date();
      let min = date.setFullYear(s[0], s[1] - 1); // 设置最小时间
      let max = date.setFullYear(e[0], e[1] - 1); // 设置最大时间
      let curr = min;
      while (curr <= max) {
        // 循环添加月份
        var month = curr.getMonth();
        var arr = [curr.getFullYear(), month + 1];
        this.selectRangeDate.push(arr);
        curr.setMonth(month + 1);
      }
    },
    getDays(day) {
      // 获取天数
      let arr = [];
      for (let i = -day; i < 0; i++) {
        // 循环添加天数
        let today = new Date(); // 获取今天
        let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * i;
        today.setTime(targetday_milliseconds); //设置i天前的时间
        let tYear = today.getFullYear();
        let tMonth = today.getMonth();
        let tDate = today.getDate();
        let date = [tYear, tMonth + 1, tDate];
        arr.push(date);
      }
      return arr;
    },
    handleSelect(name) {
      switch (name) {
        case "day":
          break;
        case "week":
          this.selectRangeDate = this.getDays(7); // 获取近一周的天数
          this.flag = true;

          break;
        case "month":
          this.selectRangeDate = this.getDays(30); // 获取近一个月的天数
          this.flag = true;
          break;
        case "filter":
          this.modal = true;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-title {
  letter-spacing: 0px;
  margin-top: 1.5vw;
  font-size: 1.3vw;
  font-weight: 700;
  color: #bf9d63;
}
.selectRange {
  width: 30%;
  margin-top: 0.5vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .time {
    display: flex;
    align-items: center;
    .part {
      margin-right: 30px;
      color: #bf9d63;
      font-size: 1vw;
    }
  }
}
</style>
<style lang="less">
.ivu-modal {
  .ivu-modal-content {
    background: #071332;

    .ivu-modal-header {
      border-bottom: 1px solid #1a3c58;

      .ivu-modal-header-inner {
        color: #75deef;
      }
    }

    .ivu-modal-body {
      text-align: center;

      .ivu-icon {
        color: #75deef;
      }

      .ivu-modal-confirm-body {
        padding-left: 0;
        color: #75deef;
      }

      .ivu-input {
        background-color: rgba(0, 0, 0, 0);
        border: 1px solid #1a3c58;
        color: #75deef;

        &::-webkit-input-placeholder {
          /* WebKit, Blink, Edge */
          color: #75deef;
        }

        &::-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #75deef;
        }

        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #75deef;
        }

        &::-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #75deef;
        }
      }

      .ivu-picker-panel-body {
        background: #071332;

        .ivu-date-picker-header {
          color: #75deef;
          border-bottom: 1px solid #1a3c58;
        }

        .ivu-date-picker-cells-cell {
          color: #75deef;

          &:hover em {
            background: #1a3c58;
          }
        }

        .ivu-date-picker-cells-cell-disabled {
          background: rgba(0, 0, 0, 0);
          color: #eee;
        }

        .ivu-date-picker-cells-focused em {
          box-shadow: 0 0 0 1px #1a3c58 inset;

          &::after {
            background: #1a3c58;
          }
        }
      }
    }

    .ivu-modal-footer {
      border-top: 1px solid #1a3c58;

      .ivu-btn-primary {
        color: #75deef;
        background: #1a3c58;
      }

      .ivu-btn-text {
        color: #ddd;

        &:hover {
          color: #75deef;
          background: #1a3c58;
        }
      }
    }
  }
}

.header {
  height: 6vw;
  //   background: #03044a;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &-title {
    color: #75deef;
    font-size: 30px;
    letter-spacing: 10px;
  }

  .selectRange {
    height: 100%;

    .ivu-menu-horizontal {
      background: rgba(255, 255, 255, 0);

      &::after {
        height: 0;
      }

      .ivu-menu-item-active {
        border-bottom: 2px solid #264e5e;
      }

      .ivu-menu-item,
      .ivu-menu-submenu {
        color: #75deef;

        &:hover {
          border-bottom: 2px solid #264e5e;
        }
      }

      .ivu-select-dropdown {
        background: #09102e;

        .ivu-menu-item {
          color: #75deef;

          &:hover {
            border-bottom: 2px solid #264e5e;
            background-color: rgba(255, 255, 255, 0);
          }
        }
      }

      .ivu-menu-submenu-title {
        i {
          margin-right: 0;
        }

        .ivu-icon-ios-arrow-down {
          display: none;
        }
      }
    }
  }
}

.page {
  height: calc(~"100% - 6vw");
}
</style>
